const filterByPathAndArea = path => perm => {
  if (perm.Path && perm.Area) {
    const regexPath = new RegExp(perm.Path);
    return regexPath.test(path);
  } else {
    return false;
  }
};
export default filterByPathAndArea;